type BlockCommentProps = {
  children: React.ReactNode;
  dataQa?: string;
};

const BlockComment = ({ children, dataQa }: BlockCommentProps) => (
  <p aria-hidden="true" data-test-id={`blockComment-${dataQa}`} hidden>
    {children}
  </p>
);

export default BlockComment;
